<!-- author:wuzhiying -->
<!-- creation Time：2020-04-03 11:30 -->
<template>
	<div class="company-notice module-item-style">
		<div class="company-notice-top">
			<p class="company-notice-title module-item-title-border-left">公司公告</p>
			<el-button type="primary" @click="show">发布公告</el-button>
		</div>
		<ul class="company-notice-listView" v-loading="loading">
			<li class="company-notice-listView-cell" v-for="(noticeItem,i) in noticeList" :key="noticeItem.createTime">
				<div class="company-notice-list-infoWrap">
					<p class="company-notice-list-content">{{noticeItem.content}}</p>
					<p class="company-notice-list-time">发布时间: {{noticeItem.createTime}}</p>
				</div>
				<div class="company-notice-btnWrap">
					<button class="company-notice-btn company-notice-edit" @click="show1(noticeItem.content,noticeItem.announcementId,noticeItem.sort)">编辑</button>
					<button class="company-notice-btn company-notice-delete" @click="deleteNotice(noticeItem.announcementId)">删除</button>
				</div>
			</li>
		</ul>
		<div class="company-notice-inputWrap">
			<el-dialog title="提示" :visible.sync="dialogFormVisible">
				<el-form :model="form">
					<el-form-item label="排序序号" :label-width="formLabelWidth">
						<el-input v-model="form.sortNumber" autocomplete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="公告内容" :label-width="formLabelWidth">
						<el-input v-model="form.content" autocomplete="off" type="textarea" maxLength="200" :rows="4" @input="changeCountNum"></el-input>
						<div class="limit-num-wrap"><span class="count-num">{{countNum}}</span>/200</div>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="addNotice">确 定</el-button>
				</div>
			</el-dialog>
			<button class="chooseAll btn">全选</button>
			<button class="removeAll btn">全部删除</button>
			<button class="removeChoose btn">选中删除</button>
			<pagenations :total="total" :size="size" @pageHandler="pageOperate"></pagenations>
		</div>
		
	</div>
</template>

<script>
	import pagenations from '@/components/pagenations/pagenations'
	export default {
		name: 'company-notice',
		components: {
			pagenations
		},
		data() {
			return {
				noticeList: [],
				total: 0,
				size: 10,
				currentPage: 1,
				dialogFormVisible: false,
				form: {
					content: "",
					sortNumber: 0,
					noticeId: "" // 公告id
				},
				formLabelWidth: '120px',
				loading:true,
				countNum:0
			}
		},
		created() {
			this.getNoticeList()
		},
		mounted() {

		},
		methods: {
			changeCountNum(e) {
				this.countNum = e.length;
			},
			/**
			 * 输入框显示
			 */
			show() {
				this.dialogFormVisible = true;
				this.form.sortNumber = 0;
				this.form.content = "";
				this.countNum = 0;
				this.form.noticeId = "";
			},
			show1(content, noticeId, sortNumber) {
				this.dialogFormVisible = true;
				this.form.content = "";
				if (content) {
					this.form.content = content;
					this.form.noticeId = noticeId;
					this.form.sortNumber = sortNumber;
				}
			},
			/**
			 * 添加或编辑公告
			 */
			addNotice() {
				if (this.form.content == "") {
					this.$message({
						message: '请输入公告内容',
						type: 'warning'
					});
					return false;
				}
				var add_param = {
					content: this.form.content
				}
				if (this.form.noticeId) {
					add_param.announcementId = this.form.noticeId;
				}
				add_param.sort = this.form.sortNumber;
				this.$http.companyNoticeAddAPI(add_param).then(res => {
					if (res.status == 1) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.dialogFormVisible = false;
						//this.currentPage = 1;
						//this.noticeList = [];
						this.getNoticeList();
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {
					console.log('err=', err)
				})
			},
			/**
			 * 删除操作
			 */
			deleteNotice(noticeId) {
				this.$confirm('确定删除该公告吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.companyNoticeDeleteAPI({
						announcementIds: noticeId
					}).then(res => {
						console.log(res)
						if (res.status == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getNoticeList();
						}else{
							this.$message.error(res.msg);
						}
					}).catch(err => {
						console.log('err=', err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			/**
			 * 分页操作
			 */
			pageOperate(val) {
				if (val.type == 'currentChange') {
					this.currentPage = val.val
				} else if (val.type == "sizeChange") {
					this.size = val.val
				}
				this.getNoticeList()
			},
			/**
			 * 获取公司公告列表
			 */
			getNoticeList() {
				this.$http.companyNoticeListAPI({
					currentPage: this.currentPage,
					pageSize: this.size
				}).then(res => {
					this.loading = false;
					if (res.status == 1) {
						this.total = res.data.count
						this.noticeList = res.data.page;
					}
				}).catch(err => {
					this.loading = false;
					console.log('err=', err)
				})
			}
		},

	}
</script>

<style lang="scss">
	.company-notice {

		.company-notice-top {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.company-notice-title {
				// margin-bottom: 34px;
			}

			.el-button--primary {
				padding: 10px 10px;
			}
		}

		.company-notice-listView {
			padding: 16px;

			.company-notice-listView-cell {
				font-size: 15px;
				padding: 15px 12px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border: 1px solid #ebeef5;
				border-bottom: none;

				.company-notice-list-infoWrap {
					max-width: 70%;

					.company-notice-list-content {
						line-height: 24px;
						margin-bottom: 16px;
					}

					.company-notice-list-time {
						color: #999999;
						font-size: 14px;
					}
				}

				.company-notice-btnWrap {
					display: flex;

					.company-notice-btn {
						background: none;
						border: 1px solid #999999;
						color: #666;
						border-radius: 6px;
						font-size: 12px;
						padding: 8px 15px;
						cursor: pointer;
						outline: none;
					}

					.company-notice-btn.company-notice-edit {
						border-color: #428efe;
						color: #428efe;
						margin-right: 16px;
					}
				}

			}

			.company-notice-listView-cell:last-child {
				border-bottom: 1px solid #eee;
			}
		}
		.btn{
			display: inline-block;
			padding: 10px 20px;
			color: #fff;
			background-color: #FF4E00;
			border-radius: 6px;
			cursor: pointer;
			border: none;
			margin: 0 12px;
			display: none;
		}
		.el-form-item__content .limit-num-wrap{
			position: absolute;
			right: 10px;
			bottom: 0px;
			font-size: 12px;
			color: #999;
		}
	}
</style>
